<template>
  <v-dialog v-model="dialog.value" persistent max-width="430">
    <template v-slot:activator="{ on: dialogOn }">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn icon outlined :color="modalColor" dark v-on="{ ...dialogOn, ...tooltipOn }">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Resetowanie postępu użytkownika</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar :color="modalColor" dark flat>
        <v-toolbar-title>Ostrzeżenie</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4">
        <p>Czy na pewno chcesz zresetować postęp użytkownika?</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="text--secondary" text :disabled="dialog.loading" @click="dialog.value = false">Nie</v-btn>
        <v-btn :color="modalColor" text :loading="dialog.loading" @click="reset">Tak</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('groups');

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    course: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      }
    };
  },
  computed: {
    modalColor() {
      return 'warning';
    }
  },
  methods: {
    ...mapActions(['resetUserCourseResults']),
    async reset() {
      this.dialog.loading = true;

      await this.resetUserCourseResults({
        courseExecutionId: this.user.courseExecutionId,
        userId: this.user.id,
        groupId: this.group.id,
        courseId: this.course.courseId,
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        search: this.search
      });

      this.dialog.loading = false;
      this.dialog.value = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
